// NotFound.jsx
import Lottie from 'lottie-react';
import { Helmet } from 'react-helmet-async';
import animationData from "../../images/team/404 blue.json"
import './404.scss'
function NotFound() {
  return (
    <div className="lottie-wrapper">
      <Helmet>
        <title>404 Error | RashTech Info</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page requested could not be found." />
        <meta property="og:title" content="404 Error | RashTech Info" />
        <meta property="og:description" content="The page requested could not be found." />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      <a href="/"><Lottie animationData={animationData} loop className="lottie-animation" /></a>
    </div>
  );
}
export default NotFound;
